@for(price of summary(); track price.text) {
@if(price.text === 'line') {
<hr>
} @else {
<div [class]="price.text">
  <span>{{ 'summary.'+price.text | uppercase | translate }}</span>
  <span>{{ price.price | price }}</span>
</div>
}
}
